const { APP_MODE, CDN_PATH, CITY } = process.env
const DEFAULT_PATH = `https://cdn.vip-wifi.com/${CDN_PATH}/${
    APP_MODE === 'production' ? '' : 'version-img/preprod/'
}config/`

const OLD_CITIES = ['cd', 'hz', 'nj']

const request = (path) => {
    return new Promise((resovle, reject) => {
        wx.request({
            url: `${DEFAULT_PATH}${path}.json`,
            data: {
                v: new Date().getTime()
            },
            success: (res) => {
                console.error('load config success', res)
                const { data, statusCode } = res
                if (statusCode === 200) {
                    resovle(data)
                } else {
                    reject(res)
                }
            },
            fail(err) {
                console.error('load config error', err)
                reject(err)
            }
        })
    })
}

const requestCity = (path) => {
    if (OLD_CITIES.includes(CITY)) {
        return request(path)
    }
    return request(`${CITY}/${path}`)
}

const getInitHomePage = (opts) => {
    const { default_config, config_path } = opts
    const getConfig = () => {
        return request(config_path)
            .then((data) => {
                return Object.assign(default_config, data)
            })
            .catch((err) => {
                console.error(err)
                return default_config
            })
    }
    return (page_instance) => {
        getConfig(page_instance).then((config) => {
            Object.keys(config).forEach((key) => {
                page_instance[key] = config[key]
            })
        })
    }
}

module.exports = {
    request,
    requestCity,
    getInitHomePage
}
